import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { DebugInfoType } from '@/types'

export interface DebugData {
    title: string
    hru: string
    data?: DebugInfoType
}

export const useDebugDialogStore = defineStore('debug', () => {
    const isOpen = ref(false)
    const debugData = ref<DebugData | null>(null)

    function setDebugData(data: DebugData) {
        debugData.value = data
        isOpen.value = true
    }

    function closeDebugDialog() {
        isOpen.value = false
        debugData.value = null
    }

    return {
        isOpen,
        debugData,
        setDebugData,
        closeDebugDialog,
    }
})
